import { LSSuburbSchema, type LSSuburb } from '#shared/types/suburb';

/**
 * Parametric fetcher (not a cached `useStore` — results depend on the search
 * args and aren't shared/deduped). Validation still happens at the `$api`
 * boundary via the passed schema.
 */
export function useSuburbStore() {
	const { $api } = useNuxtApp();

	function getSuburbs(localityID: string, suburbPartial: string): Promise<LSSuburb[]> {
		return $api('/api/Locations/getSuburbs', {
			method: 'POST',
			body: { localityID, suburbPartial },
			schema: LSSuburbSchema.array(),
		});
	}

	return {
		getSuburbs,
	};
}
